import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { Transition, dominant, form, transparentize } from "@glossy";
import Button from "@ui-kit/form/button";
import Icon from "@ui-kit/icon";

interface IProps {
  onClick: () => void;
}

const StyledButton = styled(Button)`
  width: auto;
  :focus {
    box-shadow: none;
    background-color: ${(props) =>
      transparentize(0.85, form(props, "primary"))};
  }
  &[aria-expanded="true"] {
    box-shadow: 0 0 0 2px ${dominant} inset;
    background-color: transparent !important;
  }
`;

const StyledIcon = styled(Icon)<{ toggleIcon: boolean }>`
  transition: ${Transition.Length};
  transform: rotate(${(props) => (props.toggleIcon ? 0 : 180)}deg);
  stroke-width: 2px;
`;

const RadarlyComponentsToggle = ({ onClick }: IProps) => {
  const [toggleIcon, setToggleIcon] = useState(false);
  const handleClick = useCallback(() => {
    setToggleIcon(!toggleIcon);
    onClick();
  }, [onClick, toggleIcon]);

  return (
    <StyledButton variant="primary" size="l" onClick={handleClick}>
      <StyledIcon size="ms" glyph="arrow-down" toggleIcon={toggleIcon} />
    </StyledButton>
  );
};

export default RadarlyComponentsToggle;
